<template>
  <v-dialog v-model="show" persistent width="700">
    <v-card>
      <v-card-title>
        <span class="headline">Edit</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="6" class="pb-0 mb-0">
            <v-text-field
              label="Code"
              :class="classPadding"
              v-model="ed.code"
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
            <v-text-field
              label="Description"
              :class="classPadding"
              v-model="ed.desc"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="ed.type != 'SYS'">
          <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
            <v-select
              label="Type"
              :loading="typeCodeLoading"
              :items="typeCode"
              item-text="descrp"
              item-value="typeCD"
              :class="classPadding"
              v-model="ed.type"
              clearable
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
            <v-radio-group v-model="typeGroup" row :class="classPadding" readonly>
              <v-radio label="Earning" value="EARNTYPE"></v-radio>
              <v-radio label="Deduction" value="DEDUTYPE"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row v-if="company.showNonVATEcola">
          <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
            <v-radio-group v-model="nonVATEcola" column :class="classPadding">
              <v-radio
                label="Non-Taxable (Include these earnings in the PME report field for Non-Taxable)"
                :value="0"
              ></v-radio>
              <v-radio
                label="E-Cola PME Field (Include these earnings in the PME report field for E-Cola)"
                :value="1"
              ></v-radio>
              <v-radio
                label="Fixed Allowance (Include these earnings in the PME report field for Fixed Allowance)"
                :value="2"
              ></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
            <v-radio-group v-model="alloType" column :class="classPadding">
              <v-radio
                label="Deminimis (Include these earnings in the Masterlists field for Deminimis)"
                :value="1"
              ></v-radio>
              <v-radio
                label="Salary (Include these earnings in the Masterlists field for Salary)"
                :value="2"
              ></v-radio>
              <v-radio
                label="None (Exclude these earnings in the Masterlists field)"
                :value="0"
              ></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="error" @click.stop="show = false">Close</v-btn>
        <v-btn
          text
          color="success"
          @click.stop="save"
          :loading="isSaving"
          v-if="userAccess.update >= 1"
          >Update</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import EventBus from "../../../../events/eventBus";
import { mapState, mapActions } from "vuex";
import userAccessMixin from "../../../../mixins/userAccessMixin";
// import isEmpty from "lodash/isEmpty";
const API_ENDPOINT = "/api/earnDeduc";
export default {
  metaInfo: {
    title: "Edit Earnings And Deductions",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
  mixins: [userAccessMixin],
  data: () => ({
    ed: {},
    classPadding: "my-0 py-0",
    typeCode: [],
    typeCodeLoading: false,
    typeGroup: "EARNTYPE",
    alloType: 0,
    nonVATEcola: 0,
    isSaving: false,
    show: true
  }),
  methods: {
    ...mapActions("company", ["getCompanyInfo"]),

    getTypeCode(group) {
      this.typeCodeLoading = true;

      this.$axios
        .get(`${API_ENDPOINT}/typeCode/${group}`)
        .then(({ data }) => {
          this.typeCode = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.typeCodeLoading = false;
        });
    },
    getTypes(type) {
      EventBus.$emit("SELECTED_TYPEGROUP", type);
    },
    save() {
      this.isSaving = true;
      this.ed.typeGroup = this.typeGroup;
      this.ed.tag = this.alloType;
      this.ed.nonVATEcola = this.nonVATEcola;
      this.$axios
        .post(`${API_ENDPOINT}?mode=update`, this.ed)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.getTypes(this.type);
          // this.reset();
          this.$router.go(-1);
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
    reset() {
      //this.$refs.form.reset();
      this.ed = {};
      this.typeGroup = "EARNTYPE";
      this.alloType = 0;
    },
    mapItem(item) {
      this.ed.desc = item.description;
      this.ed.code = item.code;
      // console.log(this.ed.type);
      if (item.type === "Earnings") {
        this.typeGroup = "EARNTYPE";
      } else {
        this.typeGroup = "DEDUTYPE";
      }
      this.alloType = item.alloType;
      this.ed.type = item.groupTypeCode;
      this.nonVATEcola = item.nonVATEcola;
    }
  },
  created() {
    this.getTypeCode(this.typeGroup);
    this.getUserAccessRights("EarnDeducS");
  },
  mounted() {
    this.getTypes(this.type);
    this.getCompanyInfo();
    this.mapItem(this.selectedItem);
  },
  computed: {
    ...mapState("company", {
      company: state => state.company
    }),
    ...mapState("earningDeduction", {
      selectedItem: state => state.selectedItem
    }),
    type() {
      let type = "";
      if (this.typeGroup === "EARNTYPE") {
        type = "Earnings";
      } else {
        type = "Deductions";
      }

      return type;
    }
  },
  watch: {
    typeGroup(val) {
      this.getTypeCode(val);

      this.getTypes(this.type);
    },
    show(val) {
      if (!val) {
        this.$router.push("/earnings-deduction");
      }
    }
  }
};
</script>
